export default {
    busiURL: "/business",
    userURL: "/user",
}